// project import
import { other, settings } from './other';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [other, settings]
};

export default menuItems;
